import { useEffect } from 'react';
import { useLocation } from 'react-router';

import {
  resetScrollDirection,
  scrolled,
  useScrolledDirection,
} from '#/zustand-stores/scrolledDirectionStore';

export function ScrolledDirectionGlobalHandler() {
  const { scrolledDirection } = useScrolledDirection({ threshold: 30 });

  const location = useLocation();
  useEffect(() => {
    resetScrollDirection();
  }, [location]);

  useEffect(() => {
    // touchstart
    let startY: number = 0;

    const touchstartListener = (event: TouchEvent) => {
      startY = event.touches[0].clientY;
    };

    window.addEventListener('touchstart', touchstartListener);

    // touchmove
    const touchmoveListener = (event: TouchEvent) => {
      const y = event.touches[0].clientY;
      const deltaY = startY - y;
      startY = y;
      scrolled(deltaY);
    };

    window.addEventListener('touchmove', touchmoveListener);

    // wheel

    const wheelListener = (event: WheelEvent) => {
      scrolled(event.deltaY);
    };

    window.addEventListener('wheel', wheelListener);

    return () => {
      window.removeEventListener('touchstart', touchstartListener);
      window.removeEventListener('touchmove', touchmoveListener);
      window.removeEventListener('wheel', wheelListener);
    };
  }, []);

  // Currently we only use scrolled down so "up" is not necessary
  if (scrolledDirection !== 'down') return null;

  return <div id="scrolledDirection" data-direction="down" />;
}
